// src/utils/errorHandler.ts

export interface Account {
  id: string;
  name: string;
  phone_number: string;
}

interface ApiErrorResponse {
  detail?: string;
  message?: string;
  busy_accounts?: string[]; // UUID как строки
  current_job_type?: string;
}

/**
 * Универсальная функция для красивых ошибок пользователю
 * @param err — Axios ошибка
 * @param accounts — массив всех доступных аккаунтов (чтобы показать имена)
 * @param context — опционально: что пользователь пытался сделать
 */
export const getUserFriendlyError = (
  err: any,
  accounts: Account[] = [],
  action: string = 'задачу'
): string => {
  if (!err?.response) {
    return 'Нет связи с сервером. Проверьте интернет.';
  }

  const { data, status } = err.response;

  // САМОЕ ГЛАВНОЕ: если data — это просто строка (как у тебя сейчас)
  if (typeof data === 'string') {
    return data; // ← просто покажи, что сказал бэкенд
  }

  // Если data — объект (как было раньше)
  if (status === 423 && data?.busy_accounts?.length) {
    const busyNames = accounts
      .filter(acc => data.busy_accounts.includes(acc.id))
      .map(acc => acc.name)
      .join(', ') || 'выбранные аккаунты';

    const job = data.current_job_type || 'другой задачей';

    return `Нельзя запустить ${action}\nВсе аккаунты заняты!\n\nЗаняты: ${busyNames}\nТекущая задача: ${job}\n\nДождитесь окончания или выберите другие аккаунты`;
  }

  // Остальные ошибки
  if (data?.detail) return data.detail;
  if (data?.message) return data.message;

  if (status === 401) return 'Сессия истекла. Войдите заново.';
  if (status === 403) return 'Доступ запрещён.';
  if (status === 404) return 'Не найдено.';
  if (status === 429) return 'Слишком много запросов. Подождите.';
  if (status >= 500) return 'Ошибка сервера. Мы уже чиним';

  return 'Произошла ошибка. Попробуйте позже.';
};